import { createFileRoute } from "@tanstack/react-router";

import ScoreTakerPage from "~/pages/gameSession/ScoreTakerPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/score-taking/")({
    component: ScoreTakerPage,
});
